<template>
  <MyModal
    title="经济评价"
    height="auto"
    width="454px"
    :style="{ top: '95px', left: '425px' }"
    v-if="isShow"
    @closeClick="handleCloseModalClick"
  >
    <div class="economic-content">
      <template>
        <div class="deploy-content">
          <div class="row">
            <div class="row-item">
              <div class="row-item-core">
                <div class="key">轮毂高度</div>
                <div class="value">
                  <el-select v-model="currentHeight" @change="changeHeight" placeholder="请选择">
                    <el-option
                        v-for="(item,index) in heightDatas"
                        :key="item.planId"
                        :label="item.hubHeight"
                        :value="index">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div
              :class="['row-item']"
              v-for="(item, index) in rowItemList"
              :key="index"
            >
              <div class="row-item-core">
                <div class="key">{{ item.label }}</div>
                <div class="value">
                  <StandInput
                    v-model="item.value"
                    :myType="item.type"
                    :onlyNumber="item.onlyNumber"
                    :unit="item.unit"
                    :interger="item.interger"
                    :precision="item.precision"
                  ></StandInput>
                </div>
              </div>
            </div>
            <!-- <div class="row-item">
              <div class="row-item-core">
                <div class="key">高级设置</div>
                <div class="value">
                  <div class="stand-switch-core">
                    <el-switch v-model="advanced" active-color="#6290F7">
                    </el-switch>
                  </div>
                </div>
              </div>
            </div> -->
            <template v-if="advanced">
              <div
                :class="['row-item']"
                v-for="(item, index) in seniorItemList"
                :key="index+10000"
              >
                <div class="row-item-core">
                  <div class="key">{{ item.label }}</div>
                  <div class="value">
                    <StandInput
                      v-model="item.value"
                      :myType="item.type"
                      :onlyNumber="item.onlyNumber"
                      :unit="item.unit"
                      :interger="item.interger"
                      :precision="item.precision"
                      @change="handleChange(arguments, item)"
                    ></StandInput>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="calc-area">
          <ct-button size="small" type="primary" :btnClick="saveEconomicPlan">
            开始计算
          </ct-button>
          <!-- <el-tooltip
            effect="light"
            placement="top-start"
            class="ra-tooltip"
            popper-class="my-tooltip"
          >
            <div slot="content" class="ra-tooltip-con">
              <span>
                说明：按照国家现行财税制度、现行价格、《建设项目经济评价方法与参数》（第三版）、《风电场项目经济评价规范》（NB/T31085-2016）和《陆上风电场工程可行性研究报告编制规程》（NB/T31105-2016）等对本项目进行财务效益分析，以判断其在财务上的可行性
              </span>
            </div>
            <i class="el-icon-question"> </i>
          </el-tooltip> -->
        </div>
        <div class="deploy-content line" style="white-space:nowrap;">
          <div
            class="params-item"
            v-for="(item, index) in eneryParamsList"
            :key="index+20000"
          >
            <div class="key">{{ item.name }}{{ item.unit }}</div>
            <div class="value" v-for="it in item.value">
              <el-tag>{{ it }}</el-tag>
            </div>
          </div>
        </div>
      </template>
    </div>
  </MyModal>
</template>

<script>
import MyModal from './modal';
import { mapGetters } from 'vuex';
import StandInput from './stand-input';
import { getToken } from '@/utils';
import { hasPermission } from '@/permission/index';
export default {
  components: {
    MyModal,
    StandInput,
  },
  computed: {
    ...mapGetters('WindFarm', ['projectList']),
  },
  data() {
    return {
      economicId: '',
      isShow: true,
      advanced: true,
      chartOption: null,
      singleChartOption: null,
      defaultParam: {},
      turbineUnitPrice: '',
      hubUnit: '',
      roadUnit: '',
      wireUnit: '',
      otherUnit: '',
      rowItemList: [
        {
          label: '静态投资',
          key: 'constructionInvest',
          value: null,
          onlyNumber: true,
          interger: false,
          type: 'input',
          unit: '万元',
        },
        {
          label: '满发小时数',
          key: 'equivalentHour',
          value: null,
          interger: false,
          unit: 'h',
          onlyNumber: true,
          type: 'input',
        },
        {
          label: '上网电价（含税）',
          key: 'priceWith',
          value: null,
          unit: '元/kWh',
          onlyNumber: true,
          interger: false,
          precision: 4,
          type: 'input',
        },
        {
          label: '资本金比例',
          key: 'capitalRate',
          value: null,
          interger: false,
          unit: '%',
          onlyNumber: true,
          type: 'input',
        },
        {
          label: '建设期',
          key: 'constructionPeriod',
          value: null,
          unit: '年',
          onlyNumber: true,
          interger: true,
          type: 'input',
        },
        {
          label: '运营期',
          key: 'operatingPeriod',
          value: null,
          unit: '年',
          onlyNumber: true,
          interger: true,
          type: 'input',
        },
        {
          label: '利率',
          key: 'loanInterestRate',
          value: null,
          unit: '%',
          onlyNumber: true,
          interger: false,
          type: 'input',
        },
      ],
      seniorItemList: [
        {
          label: '主机单价',
          key: 'turbineUnitPrice',
          value: null,
          unit: '元/kw',
          onlyNumber: true,
          interger: true,
          type: 'input',
        },
        /*{
          label: '塔架单价',
          key: 'hubUnit',
          value: null,
          unit: '元/吨',
          onlyNumber: false,
          interger: true,
          type: 'input',
        },
        {
          label: '道路单价',
          key: 'roadUnit',
          value: null,
          unit: '元/km',
          onlyNumber: false,
          interger: true,
          type: 'input'
        },
        {
          label: '集电线路单价',
          key: 'wireUnit',
          value: null,
          unit: '元/km',
          onlyNumber: false,
          interger: true,
          type: 'input'
        },*/
        {
          label: '其他单价',
          key: 'otherUnit',
          value: null,
          unit: '元/kw',
          onlyNumber: true,
          interger: true,
          type: 'input',
        },
      ],
      eneryParamsList: [
        {
          name: '轮毂高度',
          key: 'hubHeight',
          unit: '',
          value: [],
        },
        {
          name: 'IRR(项目税前)',
          key: 'roiBefore',
          unit: '%',
          value: 0.0,
        },
        {
          name: 'IRR(项目税后)',
          key: 'roi',
          unit: '%',
          value: 0.0,
        },
        {
          name: 'IRR(资本金)',
          key: 'cfopcIrr',
          unit: '%',
          value: 0.0,
        },
        {
          name: 'LCOE',
          key: 'lcoe',
          unit: '元/kwh',
          value: 0.0,
        },
      ],
      flowLoss: '',
      synthesizeLoss: '',
      windfarmEnergyInfo: '',
      heightDatas : [],
      currentHeight: null
    };
  },
  mounted() {},
  created() {
    // this.queryEconomicParam();
    //   if (this.projectList.length <= 0) {
    //   this.$router.push({
    //     name: 'project-list',
    //     query: {
    //       projectId: this.$route.query.projectId,
    //       projectName: this.$route.query.projectName,
    //     },
    //   });
    //   return;
    // }
    this.queryEconomic();
    setTimeout(() => {
      var layerArry = [];
      if (this.hasPerms('layer-landWspd')) {
        layerArry.push('fengziyuan');
      }
      if (this.hasPerms('layer-road')) {
        layerArry.push('zhuganlu');
      }
      this.$bus.$emit('checkLayer', layerArry);
      this.$bus.$emit('checkLayer', 'tiandi');
    });
  },
  methods: {
    hasPerms(perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms);
    },
    handleCloseModalClick() {
      this.$bus.$emit('farmClick', 3);
    },
    handleChange(val, item) {
      if (item.key === 'turbineUnitPrice') {
        this.turbineUnitPrice = val[0];
      }
      if (item.key === 'hubUnit') {
        this.hubUnit = val[0];
      }
      if (item.key === 'roadUnit') {
        this.roadUnit = val[0];
      }
      if (item.key === 'wireUnit') {
        this.wireUnit = val[0];
      }
      if (item.key === 'otherUnit') {
        this.otherUnit = val[0];
      }
      this.$postForm('/windfarm/station/getNewConstructionInvest', {
        method: 'post',
        params: {
          turbineUnitPrice: this.turbineUnitPrice,
          hubUnit: this.hubUnit,
          roadUnit: this.roadUnit,
          wireUnit: this.wireUnit,
          otherUnit: this.otherUnit,
          planId: this.heightDatas[this.currentHeight].planId,
        },
        showError: true,
        showLoading: {
          mask: true,
          loadingContent:
            '按照国家现行财税制度、现行价格、《建设项目经济评价方法与参数》（第三版）、《风电场项目经济评价规范》（NB/T31085-2016）和《陆上风电场工程可行性研究报告编制规程》（NB/T31105-2016）等对本项目进行财务效益分析，以判断其在财务上的可行性',
        },
        showSuccess: true,
      }).then((res) => {
        const { constructionInvestNew } = res.data;
        this.rowItemList.forEach((item) => {
          if (item.key === 'constructionInvest') {
            item.value = constructionInvestNew;
          }
        });
        this.heightDatas[this.currentHeight].resultList[0].constructionInvest = constructionInvestNew;
      });
    },
    saveEconomicPlan() {
      const params = this.rowItemList.reduce((acc, cur) => {
        const key = cur.key;
        const value = cur.value;
        acc[key] = value;
        return acc;
      }, {});
      this.seniorItemList.map((cur) => {
        const key = cur.key;
        const value = cur.value;
        this.$set(params, key, value);
      });
      this.$set(params, 'planId', this.heightDatas[this.currentHeight].planId);
      this.$set(params, 'projectId', this.$route.query.projectId);
      this.$set(params, 'apiKey', getToken());
      this.$set(
        params,
        'economicId',
        this.economicId === '' ? '0' : this.economicId
      );
      this.$fetch('/windfarm/station/financialCalculation', {
        method: 'post',
        data: { planEconomicList: [params] },
        showError: true,
        showLoading: {
          mask: true,
          loadingContent:
            '按照国家现行财税制度、现行价格、《建设项目经济评价方法与参数》（第三版）、《风电场项目经济评价规范》（NB/T31085-2016）和《陆上风电场工程可行性研究报告编制规程》（NB/T31105-2016）等对本项目进行财务效益分析，以判断其在财务上的可行性',
        },
        showSuccess: true,
      }).then(() => {
        this.queryEconomic();
        this.$bus.$emit('updatePlanToolIconStatus');
      });
    },
    queryEconomic() {
      this.$fetch('/windfarm/station/getPlanEconomicList', {
        params: {
          planId: this.$route.query.planId,
        },
        showError: true,
      }).then((res) => {
        const { data } = res;
        const { economicList } = data;
        if (economicList) {
          this.heightDatas = economicList;
          if(this.currentHeight == null){
            for(let i=0;i<economicList.length;i++){
              if(this.$route.query.planId == economicList[i].planId){
                this.currentHeight = i;
              }
            }
          }

          this.setEconomic(this.currentHeight);
        }
      });
    },
    setEconomic(index){
      const { resultList } = this.heightDatas[index];

      const all = this.heightDatas;
      this.eneryParamsList.forEach((item) => {
        item.value = [];
        for(let i=0;i<all.length;i++){
          if(item.key == 'hubHeight'){
            item.value.push(all[i][item.key])
          }else{
            item.value.push(all[i].resultList[0][item.key]);
          }

        }
      });
      this.rowItemList.forEach((item) => {
        if (item.label === '上网电价（含税）') {
          item.value = Number(resultList[0][item.key]).toFixed(4);
        } else {
          item.value = resultList[0][item.key];
        }
      });
      this.seniorItemList.forEach((item) => {
        if (item.key === 'turbineUnitPrice') {
          this.turbineUnitPrice = resultList[0][item.key];
        }
        if (item.key === 'hubUnit') {
          this.hubUnit = resultList[0][item.key];
        }
        if (item.key === 'roadUnit') {
          this.roadUnit = resultList[0][item.key];
        }
        if (item.key === 'wireUnit') {
          this.wireUnit = resultList[0][item.key];
        }
        if (item.key === 'otherUnit') {
          this.otherUnit = resultList[0][item.key];
        }
        item.value = resultList[0][item.key];
      });
      this.hubUnit = resultList[0].hubUnit;
      this.roadUnit = resultList[0].roadUnit;
      this.wireUnit = resultList[0].wireUnit;

      this.economicId = resultList[0].economicId;
    },
    changeHeight(v){
      this.currentHeight = v;
      this.setEconomic(this.currentHeight);
    }
  },
};
</script>

<style lang="less" scoped>
.adjust-desc-click {
  position: absolute;
  width: 320px;
  margin-right: 120px;
  margin-top: 8px;
  font-weight: 800;
  color: #ff8b24;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.economic-content {
  /*padding: 5px 10px 20px 10px;*/
  font-size: 12px;
  .core {
    // background-color: #fff;
    border-radius: 7px;
    // padding: 10px;
    .tab {
      //user-select: none;
      display: flex;
      align-items: center;
      .tab-item {
        height: 28px;
        width: 85px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #0877be;
        cursor: pointer;
        &:first-child {
          border-radius: 5px 0px 0px 5px;
        }
        &:last-child {
          border-radius: 0px 5px 5px 0px;
        }
        &.is-active {
          background-color: #0877be;
          color: #fff;
        }
      }
    }
  }

  .calc-area {
    text-align: center;
    margin-bottom: 10px;
  }
  .deploy-content {
    padding: 10px;
    color: @black-color;
    .el-tag {
      color:@black-color;
    }
    .params-item {
      display: flex;
      align-items: center;
      & > div {
        margin-right: 5px;
      }
      .key {
        width: 140px;
        font-weight: bold;
      }
      .value {
        width: 70px;
        text-align: center;
        .el-tag {
          border: none;
          background: none;
        }
      }
      .unit {
        font-size: 12px;
        color: #fff;
      }
    }
  }
  .line {
    border-top: 1px solid rgb(220, 223, 230);
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    .row-item {
      margin-bottom: 5px;
      width: 195px;
      &:nth-child(2n) {
        margin-left: 10px;
      }
      .row-item-core {
        display: flex;
        align-items: center;
        .key {
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          margin-right: 5px;
          min-width: 70px;
          padding-left: 5px;
          font-weight: 400;
          font-size: 12px;
        }
        .value {
          margin-right: 10px;
          min-width: 95px;
          font-size: 12px;
        }
      }
    }
  }

  .chart-content {
    border-radius: 7px;
    padding: 5px;
    background-color: #fff;
    margin-top: 10px;
    height: 300px;
    width: 100%;
  }
}
</style>
